import { TextareaProps } from '@mui/joy';
import {
  Control,
  FieldError,
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
} from 'react-hook-form';

import TextareaView from './TextareaView';
import TextareaWithControllerView from './TextareaWithControllerView';

interface IExtraFormFieldProps {
  setValue?: UseFormSetValue<FieldValues>;
  getValues?: UseFormGetValues<FieldValues>;
}

export interface IProps extends Omit<TextareaProps, 'error'>, IExtraFormFieldProps {
  control?: Control<FieldValues, object>;
  error?: FieldError;
  label?: string | string[];
  tooltip?: string;
  required?: boolean;
  showFieldError?: boolean;
}

const Textarea = (props: IProps) => {
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  const { setValue, getValues, ...other } = props;

  if (props?.control) {
    return <TextareaWithControllerView {...other} />;
  }

  return <TextareaView {...other} />;
};

export default Textarea;
